import { dev } from "./dev";
import { prod } from "./prod";
import { sit } from "./sit";
import { uat } from "./uat";

export interface ConfigProps{
    readonly environment: 'dev' | 'sit' | 'uat' | 'prod';
    CLIENT_ID:string,
    AUTHORITY: string,
    API_BASE_URL: string,
  };

  export function getConfig(environment: 'dev' | 'sit' | 'uat' | 'prod' | any): ConfigProps {
    switch (environment) {
      case 'dev':
        return new dev();
      case 'sit':
        return new sit();
      case 'uat':
        return new uat();
      case 'prod':
        return new prod();
      default:
        throw new Error('Invalid type');
    }
  }